function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M191.3,101.7h-29.2v-8.4h29.2V101.7z M29.2,101.2H0v-8.4h29.2V101.2z M155.4,67.3l-4.2-7.2l25.3-14.9l4.2,7.2L155.4,67.3z  M36.1,66.9L10.8,52l4.2-7.2l25.3,14.9L36.1,66.9z M132.7,41l-7.3-4.1L140,11.2l7.3,4.1L132.7,41z M59,40.7L44.4,15l7.3-4.1 l14.6,25.7L59,40.7z M100.1,29.7h-8.4V0h8.4V29.7z"
});

var SvgLightBulbRays = function SvgLightBulbRays(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "191.3px",
    height: "199.6px",
    viewBox: "0 0 191.3 199.6",
    style: {
      enableBackground: "new 0 0 191.3 199.6"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/light-bulb-rays.b4fbd061.svg";
export { SvgLightBulbRays as ReactComponent };